export default __webpack_public_path__ + "static/media/Play-Regular.dad4049d.ttf";